const jobsFilterOptions = [
  {
    label: 'Distance',
    paramLabel: 'distance',
    options: ['10 miles', '25 miles', '50 miles', '100 miles', '100+ miles'],
  },
  {
    label: 'Industry',
    paramLabel: 'industry',
    options: [],
  },
  {
    label: 'Employer',
    paramLabel: 'employer',
    options: [],
  },
  {
    label: 'Job Title',
    paramLabel: 'jobTitle',
    options: [],
  },
  {
    label: 'Salary',
    paramLabel: 'salary',
    options: [
      '$15/hr $31k/yr',
      '$20/hr $41k/yr',
      '$25/hr $52k/yr',
      '$30/hr $62k/yr',
      '$35/hr $75k/yr',
      '$40/hr+ $83k/yr+',
    ],
  },
  {
    label: 'Work Style',
    paramLabel: 'workStyle',
    options: [
      'Realistic',
      'Investigative',
      'Artistic',
      'Social',
      'Enterprising',
      'Conventional',
    ],
  },
  {
    label: 'Job Level',
    paramLabel: 'jobLevel',
    options: ['Earn & Learn', 'Gateway Jobs'],
  },
];

export default jobsFilterOptions;
